



















































import { Mixins, Component } from "vue-property-decorator";
import { DialogMixin } from "../../../../../../../base/components/system/mixins";
import { ObjectUtility } from "../../../../../../../base/utilities";
import { FormatObjectSelector, FormatObjectSelectorColumnTypes } from "../selectors";
import { ILinkedPageObjectSpecifiable } from "../../../../../../../documaker/domain/format/objects";
import { IFormatObjectSelectFilterParameter } from "./";

@Component({
  components: {
    FormatObjectSelector
  }
})
export default class FormatObjectSingleSelectDialog extends Mixins(DialogMixin) {
  selectedObject: ILinkedPageObjectSpecifiable = null;
  selectionObjects: ILinkedPageObjectSpecifiable[] = [];
  selectionColumns: FormatObjectSelectorColumnTypes[] = [];
  filteres: IFormatObjectSelectFilterParameter[] = [];
  toCellString: (column: FormatObjectSelectorColumnTypes, row: ILinkedPageObjectSpecifiable) => string = () => "";
  confirmed: boolean = false;

  $refs!: {
    selector: FormatObjectSelector,
  };

  get hasFilteres(): boolean {
    return this.filteres.length > 0;
  }

  get filteredObjects(): ILinkedPageObjectSpecifiable[] {
    return this.filteres.some(f => f.enabled)
      ? this.selectionObjects.filter(o => this.filteres.some(f => f.enabled && f.filter(o)))
      : this.selectionObjects;
  }

  get hasSelectedObject(): boolean {
    return this.selectedObject != null;
  }

  async show(
    object: ILinkedPageObjectSpecifiable,
    selectionObjects: ILinkedPageObjectSpecifiable[],
    selectionColumns: FormatObjectSelectorColumnTypes[],
    filteres: IFormatObjectSelectFilterParameter[],
    toCellString: (column: FormatObjectSelectorColumnTypes, row: ILinkedPageObjectSpecifiable) => string)
    : Promise<ILinkedPageObjectSpecifiable> {
    return this.showModal(async () => {
      this.selectedObject = ObjectUtility.copyDeeply(object);
      this.selectionObjects = selectionObjects;
      this.selectionColumns = selectionColumns;
      this.filteres = ObjectUtility.copyDeeply(filteres);
      this.toCellString = toCellString;
      this.confirmed = false;
      this.initCurrentRow();
      await this.waitHidden();
      const ret = this.confirmed
        ? this.selectedObject
        : undefined;
      this.selectedObject = null;
      this.selectionObjects = [];
      this.selectionColumns = [];
      return ret;
    });
  }

  private initCurrentRow() {
    const index = this.selectedObject
      ? !this.selectedObject.id
        ? this.selectionObjects.findIndex(v =>
          v.pageKey === this.selectedObject.pageKey &&
          v.type === this.selectedObject.type &&
          v.key === this.selectedObject.key &&
          v.subKey === this.selectedObject.subKey)
        : this.selectionObjects.findIndex(v =>
          v.pageKey === this.selectedObject.pageKey &&
          v.type === this.selectedObject.type &&
          v.id === this.selectedObject.id &&
          v.key === this.selectedObject.key &&
          v.subKey === this.selectedObject.subKey)
      : -1;
    this.$nextTick(() => this.$refs.selector.setCurrentRow(index >= 0 ? index : undefined));
  }

  clearSelectedObject() {
    this.$refs.selector.setCurrentRow();
  }

  changeObject(value: ILinkedPageObjectSpecifiable) {
    this.selectedObject = value;
  }

  confirm(): void {
    this.confirmed = true;
    this.isVisible = false;
  }

  cancel(): void {
    this.isVisible = false;
  }
}
